import React from 'react';
import PropTypes from 'prop-types';
import styles from './SignatureBlocks.scss';
import signatureBlockSizeClass from './SignatureBlockSizeClass';
import moment from 'moment-timezone';
import { Icon } from 'semantic-ui-react';

export default class SignatureBlockShow extends React.Component {
  static propTypes = {
    isTemplate: PropTypes.bool,
    openSignModal: PropTypes.func,
    signatureBlock: PropTypes.object.isRequired,
    isSigner: PropTypes.bool,
    style: PropTypes.object,
    withoutSignature: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      signatureImageHeight: 100,
      signatureImageContainer: { width: 0, height: 0 }
    };
    this.updateSignatureImageProps = this.updateSignatureImageProps.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateSignatureImageProps);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateSignatureImageProps);
  }

  updateSignatureImageProps() {
    if (this.refs.signatureImageContainer) {
      const signatureImageHeight =
        this.refs.signatureImageContainer.offsetWidth *
        this.refs.signatureImage.naturalHeight /
        this.refs.signatureImage.naturalWidth;
      this.setState({
        signatureImageOffset: (signatureImageHeight - 100) / 3,
        signatureImageHeight,
        signatureImageContainer: {
          width: this.refs.signatureImageContainer.offsetWidth,
          height: this.refs.signatureImageContainer.offsetWidth
        }
      });
    }
  }

  render() {
    const isVisible = visibility => visibility === 'SHOW';
    const { signatureBlock, style, isTemplate, withoutSignature } = this.props;
    const canSign =
      this.props.isSigner && !this.props.signatureBlock.node.signed_at;

    return (
      <div
        className={styles.signatureBlock}
        style={Object.assign(
          {},
          { padding: '1em', cursor: canSign ? 'pointer' : null },
          style
        )}
        onClick={canSign ? this.props.openSignModal : null}
      >
        <strong>
          {signatureBlock.node.signing_party}
        </strong>
        {!withoutSignature &&
          <div>
            {!signatureBlock.node.signed_at &&
              <div className={styles.signatureContainer}>
                <span className={styles.signatureImage}>&nbsp;</span>
                <span className={styles.signatureLine}>&times;</span>
              </div>}
            {signatureBlock.node.signed_at &&
              <div>
                {signatureBlock.node.signature_type === 'PAD' &&
                  <div
                    className={styles.signatureContainer}
                    ref='signatureImageContainer'
                  >
                    <img
                      alt={signatureBlock.node.name || 'Signature'}
                      src={signatureBlock.node.signature_url}
                      ref='signatureImage'
                      onLoad={this.updateSignatureImageProps}
                      className={styles.signatureImage}
                      style={{
                        bottom: 0,
                        transform: `translateY(${this.state
                          .signatureImageOffset}px)`
                      }}
                    />
                    <span className={styles.signatureLine}>&times;</span>
                  </div>}
                {signatureBlock.node.signature_type === 'TYPED' &&
                  <div className={styles.signatureContainer}>
                    <span
                      className={[
                        signatureBlockSizeClass(
                          signatureBlock.node.signature_typed_name || ''
                        ),
                        styles.signatureText
                      ].join(' ')}
                    >
                      {signatureBlock.node.signature_typed_name}
                    </span>
                    <span className={styles.signatureLine}>&times;</span>
                  </div>}
              </div>}
          </div>}
        <div>
          {isTemplate &&
            <div>
              {isVisible(signatureBlock.node.name_visibility) && <p>[Name]</p>}
              {isVisible(signatureBlock.node.company_name_visibility) &&
                <p>
                  {isVisible(signatureBlock.node.title_visibility)
                    ? '[Title], '
                    : ''}
                  [Company Name]
                </p>}
              {isVisible(signatureBlock.node.email_visibility) &&
                <p>[Email Address]</p>}
              {isVisible(signatureBlock.node.phone_visibility) &&
                <p>[Phone Number]</p>}
              {isVisible(signatureBlock.node.address_visibility) &&
                <p>[Address]</p>}
            </div>}
          {!isTemplate &&
            <div>
              {signatureBlock.node.name_visibility &&
                <p>
                  {signatureBlock.node.name}
                </p>}
              {signatureBlock.node.company_name &&
                <p>
                  {signatureBlock.node.title
                    ? `${signatureBlock.node.title}, `
                    : ''}
                  {signatureBlock.node.company_name}
                </p>}
              {signatureBlock.node.email &&
                <p>
                  {signatureBlock.node.email}
                </p>}
              {signatureBlock.node.phone &&
                <p>
                  {signatureBlock.node.phone}
                </p>}
              {signatureBlock.node.address &&
                <p style={{ whiteSpace: 'pre-wrap' }}>
                  {signatureBlock.node.address}
                </p>}
              {signatureBlock.node.signed_at &&
                <div className={styles.signatureTimestamp}>
                  <br />
                  <em>
                    Signed on{' '}
                    {moment(signatureBlock.node.signed_at).format('lll')}{' '}
                    {moment.tz(moment.tz.guess()).format('z')}
                  </em>
                  <Icon
                    name='check circle'
                    color='green'
                    style={{ marginLeft: '1em' }}
                  />
                </div>}
            </div>}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/SignatureBlocks/SignatureBlockShow.js